import { cn } from "@/lib/utils/cn";
import type { ReactNode } from "react";
export function SummaryCell({
  icon,
  label,
  value,
  note,
  tone = "default",
  progress,
  className,
}: {
  icon?: ReactNode;
  label: string;
  value: ReactNode;
  note?: ReactNode;
  tone?: "default" | "warning" | "success";
  progress?: number;
  className?: string;
}) {
  return (
    <div className={cn("space-y-2.5 px-5 py-4.5", className)}>
      <div className="text-muted-foreground flex items-center gap-2 text-[11px] font-medium">
        {icon ? (
          <span
            className={cn(
              tone === "success" && "text-emerald-600",
              tone === "warning" && "text-amber-500",
              tone === "default" && "text-muted-foreground",
            )}
          >
            {icon}
          </span>
        ) : null}
        {label}
      </div>
      <div className="text-foreground text-[15px] font-semibold">{value}</div>
      {note ? (
        <div className="text-muted-foreground text-[13px] leading-snug">
          {note}
        </div>
      ) : null}
      {progress != null ? (
        <div className="bg-muted h-1.5 overflow-hidden rounded-full">
          <div
            className={cn(
              "h-full rounded-full",
              tone === "success" ? "bg-emerald-500" : "bg-amber-500",
            )}
            style={{ width: `${Math.max(0, Math.min(progress, 100))}%` }}
          />
        </div>
      ) : null}
    </div>
  );
}
